import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
    minWidth: '1200px',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '20px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  addButton: {
    fontFamily: 'Helvetica Neue LT Std !important',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: '#DF0C36 !important',
    lineHeight: '20px !important',
    top: 0,
    zIndex: 1,
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
  },
  removeButton: {
    fontFamily: 'Helvetica Neue LT Std !important',
    fontStyle: 'normal',
    fontWeight: '500 !important',
    fontSize: '14px !important',
    color: '#DF0C36 !important',
    lineHeight: '20px !important',
    top: 0,
    zIndex: 1,
    textTransform: 'none !important',
    whiteSpace: 'nowrap',
  },
  dialog: {
    width: 300,
    height: 220,
  },
  dialogTextTitle: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '15px',
    lineHeight: '20px',
    margin: '8px 16px 25px 16px',
    color: '#000000',
  },
  dialogText: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontSize: '12px',
    lineHeight: '10px',
    margin: '8px 16px 25px 16px',
    color: '#000000',
  },
  textfield: {
    margin: '6px 15px 6px 15px',
    width: 200,
    height: 40,
    padding: '5px 5px',
    fontSize: '8px',
  },
}));
